import { render, staticRenderFns } from "./MedRecordUpdateValueFileType.vue?vue&type=template&id=5cf82cf3"
import script from "./MedRecordUpdateValueFileType.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdateValueFileType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports